type SectionHeadingProps = {
  id?: string;
  index: string;
  title: string;
  subtitle?: string;
  actionText?: string;
};

export default function SectionHeading({
  id,
  index,
  title,
  subtitle,
  actionText,
}: SectionHeadingProps) {
  return (
    <div id={id} className="flex items-end justify-between gap-4 border-b border-background-200 pb-3 scroll-mt-32">
      <div className="flex items-baseline gap-3 min-w-0">
        <span className="font-heading text-sm font-bold text-primary-500">{index}</span>
        <div className="min-w-0">
          <h3 className="font-heading text-xl md:text-2xl font-bold tracking-tight truncate">
            {title}
          </h3>
          {subtitle && (
            <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {actionText && (
        <a
          href="#cover"
          className="hidden sm:flex items-center gap-1 text-xs md:text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap cursor-pointer"
        >
          {actionText}
          <i className="ri-arrow-right-s-line"></i>
        </a>
      )}
    </div>
  );
}